export interface VehicleMakeRecord {
  altId: string;
  manufacturer: string;
}

export interface VehicleModelRecord {
  altId: string;
  modelName: string;
}

export interface VehicleOption {
  value: string;
  name: string;
}

export interface VehicleData {
  generatedAt: string;
  checksum: string;
  makes: VehicleMakeRecord[];
  modelsByMakeAltId: Record<string, VehicleModelRecord[]>;
}

import vehicleData from '../data/vehicles.json';

const data = vehicleData as VehicleData;

export function getVehicleMakes(): VehicleOption[] {
  return data.makes.map(({ altId, manufacturer }) => ({
    value: manufacturer,
    name: altId,
  }));
}

export function getVehicleModelsForMakeAltId(makeAltId: string): VehicleOption[] {
  const models = data.modelsByMakeAltId[makeAltId] || [];

  return models.map(({ altId, modelName }) => ({
    value: modelName,
    name: altId,
  }));
}

export function getVehicleMakeAltIdByManufacturer(manufacturer: string): string | undefined {
  return data.makes.find((make) => make.manufacturer === manufacturer)?.altId;
}

export function getVehicleDataMetadata() {
  return {
    generatedAt: data.generatedAt,
    checksum: data.checksum,
    makeCount: data.makes.length,
  };
}
